import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DqfApplicationEmployementComponent } from './dqf-application-employement/dqf-application-employement.component';

import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ComponentsModule } from '../shared/components/components.module';
import { LoadingGifComponent } from '../shared/loading-gif/loading-gif/loading-gif.component';
import { DqfDeclarationComponent } from './dqf-declaration/dqf-declaration.component';
import { DqfDriverSignatureComponent } from './dqf-driver-signature/dqf-driver-signature.component';
import { DqfProcessingBackgroundRequestComponent } from './dqf-processing-background-request/dqf-processing-background-request.component';
import { DqfRequestCarrierUploadInfoComponent } from './dqf-request-carrier-upload-info/dqf-request-carrier-upload-info.component';
import { DeclarationSignModule } from './native-sign-declaration/declaration-sign.module';
import { PccInstructionsDialogComponent } from './pcc-instructions-dialog/pcc-instructions-dialog.component';
import { StripeRedirectComponent } from './stripe-redirect-component/stripe-redirect.component';

@NgModule({
  declarations: [
    // Converted to standalone: DqfUploadComponent, DqfPoliceCertificateComponent, 
    // DqfPreEmploymentComponent, DqfClearHouseComponent, DqfOntarioCvorAbstractComponent, DqfViewDocumentComponent, DqfBirthLocationComponent, DqfCriminalConvictionsComponent, DqfSignaturePanelComponent, ReportIncidentComponent, AccidentDetailsComponent, AuthorityContactedComponent, PropertyDamageDetailComponent, InjuredDetailsComponent, WitnessDetailsComponent
    // Only non-standalone components should remain here
    DqfApplicationEmployementComponent,
    DqfDeclarationComponent,
    DqfRequestCarrierUploadInfoComponent,
    StripeRedirectComponent,
    PccInstructionsDialogComponent,
    DqfProcessingBackgroundRequestComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatFormFieldModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatDividerModule,
    MatBottomSheetModule,
    MatButtonModule,
    ComponentsModule,
    NgxSkeletonLoaderModule.forRoot(),
    MatStepperModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatTableModule,
    DeclarationSignModule,
    MatIconModule,
    MatSelectModule,
    LoadingGifComponent,
    MatDialogModule,
    DqfDriverSignatureComponent
    // Removed standalone component imports - they are now imported directly by the components that use them
  ]
})
export class DriverQualificationFilesModule { }
